<template>
  <div class="step2">
    <info-panel class="info">
      <span class="avatar">
        <img :src="info.wechatAvatarUrl">
      </span>
      <span class="info-item">
        手机号码:<b>{{ info.mobilePhone }}</b>
      </span>
      <span class="info-item">
        真实姓名:<b>{{ info.realName }}</b>
      </span>
    </info-panel>
    <form-title>基本信息</form-title>
    <info-panel>
      <el-form
        ref="creatStep2Form"
        :model="creatStep2Form"
        :rules="creatStep2Rules"
        label-width="140px"
      >
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item
              label="选择课程"
              prop="courseId"
            >
              <el-select
                v-model="creatStep2Form.courseId"
                placeholder="请选择课程"
                clearable
                filterable
              >
                <el-option
                  v-for="item in courseList"
                  :key="item.id"
                  :label="item.courseName"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item
              label="选择机构"
              prop="agencyId"
            >
              <el-select
                v-model="creatStep2Form.agencyId"
                placeholder="请选选择机构"
                filterable
                clearable
              >
                <el-option
                  v-for="item in agencyList"
                  :key="item.id"
                  :label="item.value"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col class="btns">
            <el-button
              @click="prev"
            >
              上一步
            </el-button>
            <el-button
              type="primary"
              @click="next"
            >
              保存
            </el-button>
          </el-col>
        </el-row>
      </el-form>
    </info-panel>
  </div>
</template>
<script>
import infoPanel from '@/components/common/infoPanel.vue';
import formTitle from '@/components/common/formTitle.vue';
import axClient from '@/services';
import { courseTypeList } from '@/config';

export default {
  name: 'CreatStep1',
  components: { infoPanel, formTitle },
  props: {
    info: {
      default: () => ({
        id: '',
        mobilePhone: '',
        realName: '',
        wechatAvatarUrl: '',
      }),
      type: Object,
    },
    form: {
      default: () => ({
        agencyId: null,
        courseList: [], // 绑定课程
        userId: '',
      }),
      type: Object,
    },
  },
  data() {
    return {
      creatStep2Form: {
        agencyId: null,
        courseId: null,
      },
      courseList: [], // 课程列表
      agencyList: [], // 机构列表
      courseTypeList,
      creatStep2Rules: {
        courseId: [
          { required: true, message: '请选择课程', trigger: 'blur' },
        ],
        agencyId: [
          { required: true, message: '请选择机构', trigger: 'blur' },
        ],
      },
    };
  },
  mounted() {
    this.getAgencyList();
    this.getCourseList();
    this.courseTypeList.shift();
  },
  methods: {
    // 上一步
    prev() {
      this.$emit('prev', 1);
    },
    // 提交
    next() {
      this.$refs.creatStep2Form.validate(async (valid) => {
        if (valid) {
          this.$emit('next', this.creatStep2Form);
        }
      });
    },
    // 获取机构列表
    async getAgencyList() {
      this.agencyList = await axClient.common.agencyListName();
    },
    // 获取课程列表
    async getCourseList() {
      this.courseList = await axClient.cert.listCourseNameByCert();
    },
  },
};
</script>
<style lang="scss" scoped>
.step2 {
  .info {
    display: flex;
    align-items: center;
    color: $--base-color-black;
    font-size: 14px;
    margin-bottom: 20px;
    .info-item {
      margin-left: 40px;
      b {
        margin-left: 10px;
      }
    }
    .avatar {
      img {
        border-radius: 50%;
        display: inline-block;
        width: 32px;
        height: 32px;
        background: #eee;
      }
    }
  }
}
</style>